module.exports = "/assets/js/61ac34d5d0786391b39cb72969775d60.svg";